import Image, { ImageProps } from '../elements/image/image';
import React from 'react';
import * as routing from '../../routing';

import styles from './menu-page-layout.module.scss';

interface TaxonTileProps {
  readonly title: string;
  readonly taxonSlug: string;
  readonly imageUrl: ImageProps['src'];
}

const TaxonTile: React.FC<React.PropsWithChildren<TaxonTileProps>> = ({
  title,
  taxonSlug: taxon,
  imageUrl,
}) => {
  return (
    <li className={styles.tile}>
      <a href={routing.products({ taxon })} className={styles.tileInner}>
        <div className={styles.tileImageContainer}>
          <Image
            role="presentation"
            alt={title}
            src={imageUrl}
            objectFit="cover"
            layout="fill"
            className={styles.tileImage}
          />
        </div>
        <span className={styles.tileTitle}>{title}</span>
      </a>
    </li>
  );
};

const Navigation: React.FC<
  React.PropsWithChildren<Record<string, unknown>>
> = ({ children }) => {
  return <div className={styles.navigation}>{children}</div>;
};

const Promotions: React.FC<
  React.PropsWithChildren<Record<string, unknown>>
> = ({ children }) => {
  return <div className={styles.promotions}>{children}</div>;
};

const MenuPageLayoutElement: React.FC<
  React.PropsWithChildren<Record<string, unknown>>
> = ({ children }) => {
  return <ul className={styles.container}>{children}</ul>;
};

const MenuPageLayout = Object.assign(MenuPageLayoutElement, {
  TaxonTile,
  Promotions,
  Navigation,
});

export default MenuPageLayout;
